export const name = 'externalServices' as const

export const ExternalServicesLoaderSymbol = Symbol('ExternalServicesLoader')
export const SSRServicesModuleLoaderSymbol = Symbol('SSRServicesModuleLoaderSymbol')
export const ServiceBundleLoaderSymbol = Symbol('ServiceBundleLoader')
